<template>
  <vx-card ref="tableQuestionRef" :id="`question-card_${answer.questionId}`" v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? 'rgba(255, 204, 0, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2">{{ questionText }}</p>
        <div v-if="answer.imageUrl" class="vx-row mb-3">
          <div class="vx-col w-full">
            <img :src="answer.imageUrl" height="200px" alt="Question Image">
          </div>
        </div>
        <div class="gridcolumns">
          <div style="text-align: -webkit-center;text-align: -moz-center;">
            <ag-grid-vue
              ref="agGridTable"
              :gridOptions="gridOptions"
              class="ag-theme-material w-full my-2 ag-grid-table"
              :style="columnwidthaggrid"
              :columnDefs="answer.tableColumns"
              :rowData="answer.tableRows"
              :defaultColDef="defaultColDef"
              @cell-clicked="onCellClicked"
              colResizeDefault="shift"
              :domLayout="'autoHeight'"
              :animateRows="true"
              >
            </ag-grid-vue>
            <span class="table-swipe-label centereverything w-full" style="margin-top: -4rem !important;padding-bottom: 2rem;"><small>Swipe to see more</small><feather-icon class="pl-2" icon="ArrowRightIcon" svg-classes="stroke-current h-3 w-3"></feather-icon></span>
          </div>
        </div>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" />

    <vs-popup id="bulkNotAddedPopup" title="Add Comment" class="vs-con-loading__container" :active.sync="cellPopup">
      <div v-if="latestCellComment.latestComment" class="mt-2 vx-row">
        <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-full">
          <label>Last Comment by {{latestCellComment.latestUserComment}}:</label>
          <vs-textarea id="studentComment" readOnly v-model="latestCellComment.latestComment" />
        </div>
        <div class="float-right vx-col">
          <div>
            <vs-button color="success" class="mr-3 vs-con-loading__container" ref="viewHistoryButton" @click.stop.prevent="showCommentHistoryPopup(answer.assessmentId)">View History</vs-button>
          </div>
        </div>
      </div>
      <div class="mt-2 vx-row w-full">
        <div class="vx-col mx-auto w-full">
          <label>Comment:</label>
          <vs-textarea color="primary" id="CommentArea" class="w-full" v-model="tableComment" />
        </div>
      </div>
      <div class="float-right vx-row mt-3">
        <vs-button :disabled="!tableComment" ref="CellPopupAddbtn" @click="addNewTableQuestionComment(answer.assessmentId)" class="mr-2">Add</vs-button>
        <vs-button @click="cellPopup = false" color="warning" type="border" >Close</vs-button>
      </div>
    </vs-popup>

    <vs-popup   ref="commentHistoryPopup" title="Comment History" :active.sync="commentHistoryPopupActive">
      <div v-if="comments.length > 0">
        <table id="commentTable" style="width: 100%;" >
          <thead>
          <tr>
            <th>Comment</th>
            <th>Created By</th>
            <th>Created On</th>
          </tr>
          </thead>
          <tbody>
          <tr class="ml-0" v-for="(item, index) in comments" :key="index">
            <td>
              {{ item.comment }}
            </td>
            <td class="nowrap">
              {{ item.commentType  }} ({{item.createdBy}})
            </td>
            <td class="nowrap">
              {{ item.createdOn.replace("T", " ").split('.')[0] }}
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div v-else>
        <p style="text-align-last: center;">No comments yet...</p>
      </div>
    </vs-popup>

  </vx-card>
</template>

<script>
  import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
  import { AgGridVue } from 'ag-grid-vue'
  import commentView from './QuizCommentView.vue';
  import 'animate.css';

  export default {
    components: {
      commentView,
      AgGridVue
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: "",
        gridApi: null,
        gridOptions: {},
        defaultColDef: {
          sortable: false,
          editable: true,
          resizable: true,
          suppressMenu: true
        },
        columnwidthaggrid: "",
        selectedRow:0,
        selectedCol:0,
        cellPopup:false,
        comments:[],
        commentHistoryPopupActive:false,
        predCommentDropdown:null,
        viewedComments:false,
        tableComment:"",
        gridTableComments:[],
        latestCellComment:{
          latestComment:"",
          latestUserComment:""
        },
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      onCellClicked(cellData){
        var self = this;
        self.tableComment = "";
        self.selectedCol = cellData.column.colDef.id;
        self.selectedRow = cellData.rowIndex;
        self.showLoadingOnElement("tableQuestionRef",1,"corners");

        var onSuccess = response =>{
          self.latestCellComment = response.data;
          self.cellPopup = true;
          self.viewedComments = false;
        }
      
        var onFinally = response =>{
          if(self.$refs.tableQuestionRef){
            self.$vs.loading.close(self.$refs.tableQuestionRef.$el);
          }
        }
      
        self.$ajaxGet(self, `QuizAssessment/GetLatestCellComment?assessmentId=${this.answer.assessmentId}&row=${self.selectedRow}&column=${self.selectedCol}` , onSuccess, onFinally);
      },
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.tableComment == null){
            self.tableComment = "";
          }
          self.tableComment += self.predCommentDropdown.label + " ";
        }
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      showCommentHistoryPopup(assessmentId){
        var self = this;
        self.comments = [];
        self.showLoadingOnElement("viewHistoryButton",0.45,"material");
        self.viewedComments = true;

        var onSuccess = function (response){
          self.comments = response.data;
          self.commentHistoryPopupActive = true;
          self.cellPopup = false;
        };

        var onFinally = function(){
          if(self.$refs.viewHistoryButton){
            self.$vs.loading.close(self.$refs.viewHistoryButton.$el); 
          }
        };

        var tableQuestionCommentsForCellDTO = {
          AssessmentId: assessmentId,
          Row: self.selectedRow,
          Column: self.selectedCol,
        };

        self.$ajaxPost(self, "QuizAssessment/GetCellComments", tableQuestionCommentsForCellDTO, onSuccess, onFinally);
      },
      addNewTableQuestionComment(assessmentId){
        var self = this;
        self.showLoadingOnElement("CellPopupAddbtn",0.45,"material");

        var onSuccess = response =>{
          self.comments = response.data;
          self.$swal.fire(
            'Comment Addedd',
            'Your Comment has been Addedd',
            'success'
          );
          self.cellPopup = false;
          if(response.data[0].assessmentId){
            self.answer.assessmentId = response.data[0].assessmentId
          }
        }
      
        var onFinally = response =>{
          if(self.$refs.CellPopupAddbtn){
            self.$vs.loading.close(self.$refs.CellPopupAddbtn.$el);
          }
        }
        var sendData = {
          "Comment":  `${self.selectedRow}#${self.selectedCol}#${self.tableComment}`,
          "CommentType": "Student" ,
          "assessmentId": assessmentId,
        };
        if(assessmentId == 0){
          sendData.questionId = self.answer.questionId;
          sendData.logId = self.$route.query.TaskLogId;
        };

        self.$ajaxPost(self, "QuizAssessment/AddCommentTableQuestion" , sendData , onSuccess, onFinally);
      },
      highlightCol(){
        var self = this;
        var comments = this.answer.comments.filter(x=>x.comment.includes('#'));
        var tableColumns = this.answer.tableColumns;
        var commentColumns = [] ;

        commentColumns = comments.map(function(element) {
          var commentSplit = element.comment.split('#');
          return {
            "row": parseInt(commentSplit[0]) + 2,
            "column":commentSplit[1]
          };
        });

        var elementRows = [];
        var elements = [];
        setTimeout(() => {
          elements = document.getElementsByClassName('ag-row ag-row-no-focus ag-row-level-0 ag-row-position-absolute')

          elements.forEach(element => {
            if(!element.innerHTML.includes("ag-header")){  //this.answer.tableColumns.length
              elementRows.push(element);
            }
          });
          elementRows.forEach(element2 => {
            var currentRow = commentColumns.filter(x=>x.row.toString() == element2.ariaRowIndex)
            if(currentRow.length != 0){
              
              element2.children.forEach(element => {
                var colNumber = tableColumns.filter(x=>x.number +1 == element.ariaColIndex);
                if(colNumber.length != 0 && currentRow.filter(x=>x.column == colNumber[0].id).length != 0){
                  element.className += ' cell-fail';
                }
              });
            }
          });
        }, 50);
        
      }
    },
    mounted() {
      var self = this;
      if(self.answer){
        self.questionText = self.strip(self.answer.questionText);
        self.questionTitle = self.strip(self.answer.questionTitle);
      }
      
      self.gridApi = self.gridOptions.api;
      if(window.innerWidth > 900){
        self.gridApi.sizeColumnsToFit();
      }

      else{
        var columnsLength = self.answer.tableColumns.length;
        self.columnwidthaggrid = (columnsLength * 200.5).toString();
        self.columnwidthaggrid = "width: " + self.columnwidthaggrid + "px !important";
      }
      setTimeout(() => {
        self.highlightCol();  
      }, 200);

    }
  }

</script>

<style lang="scss">
  // .ag-grid-table {
  //   height: calc(100vh - 33rem) !important;
  //   border: 0.5px solid #e2e2e2 !important;

  //   &.ag-theme-material {
  //     .ag-header-cell {
  //       border-right: solid .1pt #eaeaea !important;
  //       &:hover {
  //         background-color: rgb(220, 220, 220) !important;
  //       }
  //     }
  //   }

  //   .ag-cell-focus:not(.ag-cell-range-selected) {
  //     border: 1px solid !important;
  //     border-color: #3f51b5 !important;
  //   }

  //   .ag-cell {
  //     cursor: pointer;
  //     border-right: solid .1pt #eaeaea !important;
  //     border-left: solid .1pt #eaeaea !important;
  //     &:hover {
  //       background-color: rgb(220, 220, 220) !important;
  //     }
  //   }
  // }


  .ag-cell{
    padding: 0px !important;
    flex: 1 1 auto;
    justify-content: center;
    text-align: center !important;
    cursor: pointer;
    border-right: solid .1pt #eaeaea !important;
    border-left: solid .1pt #eaeaea !important;
    &:hover {
      background-color: rgb(220, 220, 220) !important;
    }
  }

  .ag-header-cell-label{
    flex: 1 1 auto;
    justify-content: center;
  }
  .ag-header-cell{
    padding: 0px !important;
    text-align: center;
  }
  .cellItems{
    display: unset !important;
    flex: unset !important;
    align-items: unset !important;
    align-self: unset !important;
    text-align: center !important;
    
  }

  #cellTextArea, #cellViewArea {
    height: 200px;
  }

  #cellTextPopup, #cellViewPopup {
    .vs-component.vs-con-textarea.vs-textarea-primary:not(.focusx){
      border-color: #828282 !important;
    }

    .focusx.vs-textarea-primary {
      border: 1px solid rgba(var(--vs-primary),1)!important;
    }

    z-index: 99999;
  }

  .ag-grid-table {
    height: -webkit-fill-available !important;
    border: 0.5px solid #e2e2e2 !important;
    &.ag-theme-material {
      .ag-header-cell {
        border-right: solid .1pt #eaeaea !important;
        &:hover {
          background-color: rgb(220, 220, 220) !important;
        }
      }
    }

    .ag-cell-focus:not(.ag-cell-range-selected) {
      border: 1px solid !important;
      border-color: #3f51b5 !important;
    }
  }

  .ag-grid-table{
    margin-bottom: 5rem !important;
  }

  .textcenter{
    text-align: center !important;
  }

  @media only screen and (max-width: 400px){
    .ag-header-cell-label{
      overflow: auto;
      .ag-header-cell-text{
        overflow: auto;
        width: 100%;
        height: 100%;
        align-items: center;
        white-space: initial !important;
      }
    }
  }

  .gridcolumns{
    overflow: auto;
    width: 100% !important;
  }

  .cell-fail{
    background-color: rgba(255, 0, 0, 0.6)  !important;
  }

</style>
